import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SimButtonModule } from '@simOn/ui/sim-button';
import { SimIconComponent } from '@simOn/ui/sim-icon';
import { SimSaveButtonComponent } from '../save-button/save-button.component';
import { SimSidePanelComponent } from '../side-panel/side-panel.component';

@Component({
  selector: 'sim-edit-panel',
  standalone: true,
  imports: [SimSidePanelComponent, SimIconComponent, SimButtonModule, SimSaveButtonComponent],
  templateUrl: './edit-panel.component.html',
  styleUrl: './edit-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimEditPanelComponent {
  readonly icon = input<string>();
  readonly iconSizeInPx = input(20);
  readonly heading = input<string>('');
  readonly saveLabel = input<string>($localize`:@@SAVE_CHANGES:Save changes`);
  readonly canSave = input<boolean>(false);
  readonly saving = input<boolean>(false);
  readonly loading = input<boolean>(false);

  readonly closePanel = output<void>();
  readonly save = output<void>();
}
